import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IAddTransactionReportRequest {
    page: number;
    size: number;
    filters: Array<any>
}

async function AddTransactionReportRequest(
    data: IAddTransactionReportRequest
): Promise<any> {
    try {
        return (await axiosInstance.post("/Transaction/AddTransactionReportRequest", data)).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useAddTransactionReportRequest() {
    return useMutation<any, Error, IAddTransactionReportRequest>((variables) =>
        AddTransactionReportRequest(variables)
    );
}
